// @flow
import EventEmmiter from 'events';

const CHANGE_EVENT = 'flux_store_changed';

export default class Store extends EventEmmiter {
  constructor() {
    super();
  }

  subscribe = (observer: () => void) => {
    this.addListener(CHANGE_EVENT, observer);
  };

  unsubscribe = (observer: () => void) => {
    this.removeListener(CHANGE_EVENT, observer);
  };

  notify = () => {
    this.emit(CHANGE_EVENT);
  };
}
